import {
  Component,
  computed,
  effect,
  inject,
  input,
  InputSignal,
  OnInit,
  Signal,
  ViewEncapsulation,
} from '@angular/core';
import {interval, tap} from "rxjs";
import {filter} from "rxjs/operators";
import {EsvgFiles, IApiControl, IFilter, SignalControl} from 'frontier/nucleus';
import {SelectionModel} from '@angular/cdk/collections';
import {IBarClickedEvent} from './evaluation/bar-click-event.interface';
import {Processes} from './processes.type';
import {ECalculusStateFilter} from 'src/app/home/config/state-filter.enum';
import {ICartStatusApiData} from '../../../config/cart-status-data.interface';
import {CartStatuses} from '../../../config/cart-status-data.const';
import {ProcessOverviewStore} from '../service/process-overview.store';
import {EvaluationComponent} from './evaluation/evaluation.component';
import {ClientAccessComponent} from './evaluation/client-access/client-access.component';
import {EvaluationOnHoldComponent} from './evaluation/evaluation-on-hold/evaluation-on-hold.component';
import {MatIcon} from '@angular/material/icon';
import {NgClass} from '@angular/common';
import {ToolbarStore} from 'frontier/browserkit';
import AppControlGuids from '../../../../api/ControlGuids';
import {IProcessState} from "../service/state.interface";
import {CalculusStore} from "../../../../Services/calculus.store";


@Component({
  selector: 'kpi4me-process-header',
  templateUrl: './process-header.component.html',
  styleUrls: ['./process-header.component.scss'],
  encapsulation: ViewEncapsulation.Emulated,
  standalone: true,
  imports: [NgClass, MatIcon, EvaluationOnHoldComponent, ClientAccessComponent, EvaluationComponent]
})
export class ProcessHeaderComponent extends SignalControl<ICartStatusApiData, Processes> implements OnInit {
  private _processOverviewService: ProcessOverviewStore = inject(ProcessOverviewStore);
  calculusStore: CalculusStore = inject(CalculusStore);

  protected readonly EsvgFiles = EsvgFiles;
  override GUID: string = AppControlGuids.TFullCartStatus;
  ECalculusStateFilter = ECalculusStateFilter;

  processes: Signal<Processes> = this.data;
  preventUpdate: InputSignal<boolean> = input<boolean>(false);
  selectedProcess: Signal<IProcessState> = this._processOverviewService.selectedProcess;
  processSelection: Signal<SelectionModel<IProcessState>> = computed<SelectionModel<IProcessState>>(() =>
    new SelectionModel<IProcessState>(false, [this.selectedProcess()])
  );

  selectedCategory: Signal<ECalculusStateFilter> = computed(() => this.processSelection().selected[0].category)

  private _toolbarService = inject(ToolbarStore);

  constructor() {
    super();
    effect(() => {
      const toolbarFilterDto: IFilter = this._toolbarService.toolbarFilterDto();
      const apiInstance: IApiControl = this.apiInstance();
      if (toolbarFilterDto && apiInstance) {
        this.patchFilter({
          ...toolbarFilterDto,
        })
      }
    }, {allowSignalWrites: true});
  }

  override toModel(d: ICartStatusApiData): Processes {
    const processes: Processes = [...CartStatuses.values()] as Processes;
    processes[0].data = d.kpiconnect;
    processes[1].data = d.etlnmap;
    processes[2].data = d.check;
    processes[3].data = d.createinvoice;
    processes[4].data = d.arrangeinvoice;
    processes[5].data = d.monitorpayment;
    processes[6].data = d.total;
    processes[7].data = [d.onhold, d.clientmessage, d.uncollectible];
    processes[8].data = [d.clientmessage, d.uncollectible, d.onhold];
    processes[9].data = [d.uncollectible, d.onhold, d.clientmessage];
    return processes;
  }

  ngOnInit(): void {
    this.subs.add(
      interval(10000)
        .pipe(
          filter(_ => !this.preventUpdate()),
          tap(_ => this.changeAndFetchInstance()),
        )
        .subscribe()
    );
  }

  onProcessClick(category: ECalculusStateFilter): void {
    this._processOverviewService.selectedProcessCategory$.next(category);
  }

  onBarClicked(evt: IBarClickedEvent, category: ECalculusStateFilter): void {
    // stop propagation to parent button
    evt.event.stopPropagation();
    this._processOverviewService.selectedProcessState$.next({category, state: evt.state});
  }

  isCategorySelected(categoryId: ECalculusStateFilter): boolean {
    return this.selectedCategory() === categoryId;
  }

  showHelpForEvaluation(): void {
    this.calculusStore.helpRoute$.next('prozessübersicht.html#prozessauswertung');
  }
}
